<template>
    <div>
        123
    </div>
</template>
<script>
export default {
    data:function(){
        return {
            
        }
    },
    methods:{
        
    },
    mounted(){
        
    },
    computed:{
    },
    watch:{
    }
}
</script>
<style lang="less" scoped>
</style>














// WEBPACK FOOTER //
// src/views/new/newslist1.vue